<template>
  <div class="form-group">
    <label v-if="label" :for="id" v-bind:class="{required: hasRequired}">{{label}}</label>
    <div class="input-group">
      <textarea v-on="textAreaListeners"
                class="form-control"
                :id="id"
                v-bind="$attrs"
                v-bind:value="value"
                v-bind:class="{ 'is-invalid': validation.$error }"></textarea>
      <div class="input-group-append">
        <slot name="input-append" />
      </div>
      <div class="invalid-feedback">
        {{errorMessage}}
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationMixin } from '@/js/Mixins';

export default {
  name: 'base-texarea',
  mixins: [ValidationMixin],
  props: ['label', 'value'],
  mounted() {
    this.id = `textarea-${this._uid}`;
  },
  data() {
    return {
      id: null,
    };
  },
  computed: {
    textAreaListeners() {
      const vm = this;
      return Object.assign({}, this.$listeners, {
        input(event) {
          vm.$emit('input', event.target.value);
        },
      });
    },
  },
};
</script>

<style scoped>

</style>
